module.exports = "h1 {\r\n    color: black;\r\n    text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;\r\n    }\r\nh6 {\r\n    color: black;\r\n    text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/index/index.component.css
// module id = ./src/app/index/index.component.css
// module chunks = main